<div class="padding-l60 padding-b10">
<button id="ebz-checkout-btn"  style="color:white" class="primary" mat-flat-button>Pay Now</button>
</div>